import {
  MarketingSection,
  SectionIntro,
  SectionTitle,
} from "@/components/marketing/MarketingSection";
import LineIcon from "@/components/marketing/sections/LineIcon";
import { cn } from "@/lib/utils";

const CARDS = [
  {
    title: "For fans who want to go deeper",
    body: "Instrumentals and acapellas let your biggest fans hear the production and performance from a different perspective.",
    card: "bg-[linear-gradient(145deg,#fff_35%,#eef0ff)]",
    tone: "bg-[#E9ECFF] text-blue-600",
    icon: (
      <>
        <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
        <path d="M4 14h3v6H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 1-2Zm16 0h-3v6h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-1-2Z" />
      </>
    ),
  },
  {
    title: "For DJs who need more versions",
    body: "Instrumentals, acapellas, and clean edits give DJs useful options for their sets and mixes.",
    card: "bg-[linear-gradient(145deg,#fff_35%,#fff0f7)]",
    tone: "bg-[#FFE1EF] text-[#B01861]",
    icon: (
      <>
        <circle cx="12" cy="12" r="8" />
        <circle cx="12" cy="12" r="2" />
        <path d="M17.5 6.5 21 3m-2 0h2v2M5 19h14" />
      </>
    ),
  },
  {
    title: "For collectors who want the extras",
    body: "Exclusive videos, personal notes, and bonus content make your release something worth adding to their collection.",
    card: "bg-[linear-gradient(145deg,#fff_35%,#edfff7)]",
    tone: "bg-[#D9FFF8] text-[#0D8178]",
    icon: (
      <>
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="2" />
        <path d="M12 3v4m0 10v4M3 12h4m10 0h4" />
      </>
    ),
  },
  {
    title: "For artists who want to offer more value",
    body: "Build a fuller package around the song you already made and set a price that reflects what’s included.",
    card: "bg-[linear-gradient(145deg,#fff_35%,#f4f0ff)]",
    tone: "bg-[#EEE5FF] text-[#6935CB]",
    icon: <path d="M12 5v14M5 12h14" />,
  },
];

export default function SuperFanSection() {
  return (
    <MarketingSection className="bg-[#F7F8FB]">
      <SectionTitle>Give fans more worth paying for.</SectionTitle>
      <SectionIntro className="!max-w-[840px]">
        Some listeners want more than the original song. From dedicated fans to
        DJs, a Super Single gives buyers more reasons to choose your release,
        with alternate versions and exclusive content in one package.
      </SectionIntro>
      <div className="mt-12 grid auto-rows-[1fr] grid-cols-2 gap-[22px] max-[680px]:grid-cols-1">
        {CARDS.map((card) => (
          <article
            key={card.title}
            className={cn(
              "min-h-[230px] rounded-[24px] border border-[#DFE3F1] p-[30px]",
              card.card,
            )}
          >
            <div
              aria-hidden
              className={cn(
                "mb-7 grid size-[46px] place-items-center rounded-[14px]",
                card.tone,
              )}
            >
              <LineIcon className="size-[25px]">{card.icon}</LineIcon>
            </div>
            <h3 className="m-0 mb-[10px] font-figtree text-[23px] font-[850] leading-[1.18]">
              {card.title}
            </h3>
            <p className="m-0 font-open-sans text-[16px] leading-[1.55] text-marketing-muted">
              {card.body}
            </p>
          </article>
        ))}
      </div>
    </MarketingSection>
  );
}
